import React from 'react'

function CloudComputingServiceDetails() {
    return (
        <div>
            <div className="services-details-area default-padding">
                <div className="cotnainer">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="site-heading text-center">
                                <h4 className="sub-title">Website Development</h4>
                                <h2 className="title">Build a Website That Grows as Fast as Your Business</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="services-details-items">
                        <div className="row">
                            <div className="col-xl-12 services-single-content">
                                <div className="thumb mb-50">
                                    <img src="static/img/cloudcomputing/21.jpg" alt="Thumb" />
                                </div>
                                <p>
                                    At Microcode Software, we don't simply develop websites - we design robust digital experiences meant to engage your audience and achieve results. Every site we build is customized using your branding and business objectives to provide a unique experience for your audience. All sites consider performance, usability and scalability to ensure that the custom web development solutions we provide remain flexible. Not only do our sites look great, they are designed for the long-term.
                                </p>
                                <div className="process-style-one-items mt-50">
                                    <div className="choose-us-one-thumb">
                                        <div className="content">
                                            <div className="left-info">
                                                <h2 className="title">
                                                    Turn Clicks Into Clients With a Site That Performs
                                                </h2>
                                            </div>
                                            <div className="process-style-one">
                                                <div className="process-style-one-item">
                                                    <span>01</span>
                                                    <h4>Explore & Discover</h4>
                                                    <p>
                                                        We understand your business, priorities, and audience so that we can create a distinctive strategic road map.
                                                    </p>
                                                </div>
                                                <div className="process-style-one-item">
                                                    <span>02</span>
                                                    <h4>Design & Construct </h4>
                                                    <p>
                                                        We design gorgeous, easy-to-use designs, and build a high performing website that represents your brand.
                                                    </p>
                                                </div>
                                                <div className="process-style-one-item">
                                                    <span>03</span>
                                                    <h4>Test, Launch & Ongoing Support</h4>
                                                    <p>
                                                        We test thoroughly, launch smoothly, and provide ongoing support for your website, so you can focus on your business.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CloudComputingServiceDetails
